import { Navigate } from 'react-router-dom'
import { useAuth } from '@/context/AuthContext'
import LoadingScreen from '../app/auth/components/LoadingScreen'
import { UserRole } from '@/types'

interface ProtectedRouteProps {
  children: JSX.Element
  allowedRoles?: UserRole[]
}

export default function ProtectedRoute({ children, allowedRoles = [] }: ProtectedRouteProps) {
  const { user, loading } = useAuth()

  if (loading) return <LoadingScreen />
  if (!user) return <Navigate to="/auth" replace />

  // Check if user has required role
  if (allowedRoles.length > 0 && user.role && !allowedRoles.includes(user.role as UserRole)) {
    // Redirect to appropriate dashboard based on user role
    if (user.role === 'landlord') return <Navigate to="/dashboard/landlord" replace />
    if (user.role === 'client') return <Navigate to="/dashboard/client" replace />
    if (user.role === 'admin') return <Navigate to="/admin/dashboard" replace />
    return <Navigate to="/auth" replace />
  }

  return children
}